<template>
  <div>
    <v-layout row v-if="alertMessage" mb-3>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <app-alert @dismissed="dismiss" :text="alertMessage"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center>
      <v-flex xs12 text-xs-center>
        <h1 class="display-1">Activate Your SIM</h1>
        <p>To begin, enter the <strong>Activation PIN</strong> on your SIM Kit.</p>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <v-form 
          @submit.prevent="submit()"
          v-model="valid"
          ref="form"
          lazy-validation
          class="mb-4">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
              label="Activation PIN"
              v-model="pin"
              :rules="[rules.required, rules.pin]"
              :counter="10"
              required></v-text-field>
            </v-flex>
            <v-flex xs12 class="text-xs-right">
              <v-btn 
                @click="submit" 
                class="mr-0"
                outline
                color="primary"
                :loading="loading"
              >Continue</v-btn>
            </v-flex>
          </v-layout>          
        </v-form>        
      </v-flex>      
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <v-layout>
          <v-flex xs12>
            <v-card flat class="pa-2">
              <v-card-text>
                <p>Please scratch the area on the bottom right of your Ice Wireless SIM Card to reveal your Activation PIN.</p>
              </v-card-text>
              <v-card-media
                :src="getImgUrl('trio-SIM.png')"
                height="200px"              
                contain></v-card-media>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "VerifyPIN",
  data() {
    return {
      valid: true,
      pin: null,
      alertMessage: null,
      rules: {
        required: value => !!value || "Required",
        pin: value => {
          if (this.brand.rules.pin) {
            return this.brand.rules.pin(value);
          } else {
            if (value != null && value.length >= 4 && value.length <= 10) {
              return true;
            } else {
              return "Invalid PIN";
            }
          }
        }
      }
    };
  },
  mounted() {
    // await this.$store.dispatch("resetSim");
    this.$store.dispatch("clearDetails");
  },

  computed: {
    sim() {
      return this.$store.getters.sim;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    error(val) {
      if (!val) {
        this.alertMessage = null;
        return;
      }

      var status = val.response.status;
      switch (status) {
        case 403:
          const {
            message: message = "This SIM may have already been activated. Verify the PIN # or contact support."
          } = val.response.data.error;
          this.alertMessage =
            "This SIM may have already been activated. Verify the PIN # or contact support.";
          break;

        case 500:
          this.alertMessage = "Oops, Something went wrong. Please try again later.";
          break;
      }
    },
    sim(val) {
      if (val !== null && val !== undefined) {
        // this.$router.push('/')
        this.$router.push({ name: "select-plan" });
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.dismiss();
        this.$store.dispatch("verifyPin", this.pin).catch(e => {
          console.log("e: ", e);
        });
      }
    },
    dismiss() {
      this.$store.dispatch("clearError");
      this.alertMessage = null;
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/activation/VerifyPIN.vue